import Vue from 'vue'
import VueRouter from 'vue-router'
import layOut from "../views/layOut";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'cover',
    component: () => import('@/views/coverPage.vue')
  },
  {
    path: '/chooseOrg',
    component: () => import('@/views/chooseOrg.vue')
  },
  {
    path: '/main',
    component: () => import('../views/layOut.vue'),
    redirect: '/main/production',
    children: [
      {
        path: 'production',
        component: () => import('../views/home/productionList.vue')
      },
      {
        path: 'device',
        component: () => import('../views/home/deviceList.vue')
      },
      {
        path: 'productionInfo',
        component: () => import('../views/home/productionInfo')
      },
      {
        path: 'deviceInfo',
        component: () => import ('../views/home/deviceInfo1')
      },
      {
        path: 'deviceDetail',
        component: () => import ('../views/home/deviceInfo2')
      },

    ]
  },
  {
    path: '/create',
    component: () =>import ('../views/create/production.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
